export const engingeeredSFComplete = new Map([
  [11, "Mon-Fri 5 per week"],
  [12, "Mon-Sat 6 per week"],
  [13, "Mon-Sun 7 per week"],
  [19, "Sat 1 per week"],
  [20, "Sun 1 per week"],
  [21, "Mon 1 per week"],
  [22, "Tue 1 per week"],
  [23, "Wed 1 per week"],
  [24, "Thu 1 per week"],
  [25, "Fri 1 per week"],
  [26, "Mon+Wed+Fri 3 per week"],
  [27, "Mon+Wed 2 per week"],
  [28, "Tue+Thu 2 per week"],
  [29, "Wed+Fri 2 per week"],
  [30, "return Mon, Tue, Wed 3 per week"],
  [31, "return Mon, Tue, Thu 3 per week"],
  [32, "return Mon, Tue, Fri 3 per week"],
  [33, "return Mon, Wed, Thu 3 per week"],
  [34, "return Tue, Wed, Thu 3 per week"],
  [35, "return Tue, Wed, Fri 3 per week"],
  [36, "return Tue, Thu, Fri 3 per week"],
  [37, "return Wed, Thu, Fri 3 per week"],
  [38, "return Mon, Thu, Fri 3 per week"],
  [40, "return Mon, Tue 2 per week"],
  [41, "return Mon, Thu 2 per week"],
  [42, "return Mon, Fri 2 per week"],
  [43, "return Tue, Wed 2 per week"],
  [44, "return Tue, Fri 2 per week"],
  [45, "return Wed, Thu 2 per week"],
  [46, "return Thu, Fri 2 per week"],
  [47, "return Mon, Wed, Thu, Fri 4 per week"],
  [48, "return Mon, Tue, Wed, Fri 4 per week"],
  [97, "return Tue-Fri 4 per week"],
  [98, "Mon-Thu 4 per week"],
  [99, "Mon, Tue, Thu, Fri 4 per week"],
  [311, "1st+3rd Mon per month (0,5 per week)"],
  [312, "1st+3rd Tue per month (0,5 per week)"],
  [313, "1st+3rd Wed per month (0,5 per week)"],
  [314, "1st+3rd Thu per month (0,5 per week)"],
  [315, "1st+3rd Fri per month (0,5 per week)"],
  [321, "2nd+4th Mon per month (0,5 per week)"],
  [322, "2nd+4th Tue per month (0,5 per week)"],
  [323, "2nd+4th Wed per month (0,5 per week)"],
  [324, "2nd+4th Thu per month (0,5 per week)"],
  [325, "2nd+4th Fri per month (0,5 per week)"],
  [411, "1st Mon per month (0,25 per week)"],
  [412, "1st Tue per month (0,25 per week)"],
  [413, "1st Wed per month (0,25 per week)"],
  [414, "1st Thu per month (0,25 per week)"],
  [415, "1st Fri per month (0,25 per week)"],
  [421, "2nd Mon per month (0,25 per week)"],
  [422, "2nd Tue per month (0,25 per week)"],
  [423, "2nd Wed per month (0,25 per week)"],
  [424, "2nd Thu per month (0,25 per week)"],
  [425, "2nd Fri per month (0,25 per week)"],
  [431, "3rd Mon per month (0,25 per week)"],
  [432, "3rd Tue per month (0,25 per week)"],
  [433, "3rd Wed per month (0,25 per week)"],
  [434, "3rd Thu per month (0,25 per week)"],
  [435, "3rd Fri per month (0,25 per week)"],
  [441, "4th Mon per month (0,25 per week)"],
  [442, "4th Tue per month (0,25 per week)"],
  [443, "4th Wed per month (0,25 per week)"],
  [444, "4th Thu per month (0,25 per week)"],
  [445, "4th Fri per month (0,25 per week)"],
]);
